// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:01:17

export default {
  "id": "super-cloner-3d",
  "slug": "super-cloner-3d",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/380ccebe6f4e47858652059763061f0e-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/380ccebe6f4e47858652059763061f0e/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Super Cloner 3D",
      "description": "In Super Cloner 3D, you are a unique super cloner on a mission to infiltrate dangerous environments. Use your cloning powers to escape traps, kill enemies, and accomplish secret missions. ",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "danger",
        "enemies",
        "mission",
        "skill"
      ]
    },
    "zh-CN": {
      "title": "超级克隆3D",
      "description": "在《超级克隆者3D》中，你是一位独特的超级克隆者，肩负着潜入危险环境的任务。利用你的克隆能力逃脱陷阱、消灭敌人并完成秘密任务。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "冒险"
      ],
      "tags": [
        "危险",
        "敌人",
        "任务",
        "技能"
      ]
    },
    "zh-TW": {
      "title": "超複製3D",
      "description": "在《超複製者3D》中，你是一個獨特的超複製者，負責潛入危險環境。利用你的複製能力來逃離陷阱、擊敗敵人，並完成秘密任務。",
      "instructions": "滑鼠點擊或觸控開始遊戲",
      "genres": [
        "冒險"
      ],
      "tags": [
        "危險",
        "敵人",
        "任務",
        "技能"
      ]
    },
    "zh-HK": {
      "title": "超克隆3D",
      "description": "在《超複製者3D》中，你是一個獨特的超複製者，執行潜入危險環境的任務。利用你的複製能力來逃離陷阱、殺敵並完成秘密任務。",
      "instructions": "用鼠標點擊或觸控玩遊戲",
      "genres": [
        "冒險"
      ],
      "tags": [
        "危險",
        "敵人",
        "任務",
        "技能"
      ]
    },
    "ja": {
      "title": "スーパークローナー3D",
      "description": "スーパークローナー3Dで、あなたは特殊なスーパークローナーとして、危険な環境に潜入するミッションに参加しています。クローニングの力を使って罠から逃げ、敵を倒し、秘密のミッションを達成してください。",
      "instructions": "マウスクリックまたはタップで遊ぶ",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "危険",
        "敵",
        "ミッション",
        "スキル"
      ]
    },
    "ko": {
      "title": "스upe르 클론 3D",
      "description": "스upe Cloner 3D에서는 위험한 환경에 침투하기 위한 독특한 슈퍼 클론으로서의 미션을 수행합니다. 복제 능력을 사용하여 유인물을 피하고 적을 죽이며 비밀 임무를 성취하세요.",
      "instructions": "마우스 클릭 또는 탭하여 플레이하세요",
      "genres": [
        "모험"
      ],
      "tags": [
        "위험",
        "적",
        "임무",
        "스킬"
      ]
    },
    "fr": {
      "title": "Super Cloner 3D",
      "description": "Dans Super Cloner 3D, vous êtes un super clonage unique en mission pour infiltrer des environnements dangereux. Utilisez vos pouvoirs de clonage pour échapper aux pièges, tuer les ennemis et accomplir des missions secrètes.",
      "instructions": "Cliquez sur la souris ou appuyez pour jouer",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "dangereux",
        "ennemis",
        "mission",
        "compétence"
      ]
    }
  }
};
